export default () => ({
  notifications: [],
  error: '',
});
